var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-switch',{attrs:{"label":_vm.formData ? 'Sim' : 'Não'},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }